var bx = {};


// 获取是否所有人都可以预订保险
/**
 * @name 判断处理人是否都可以预订保险
 * 
 * **/ 

/**
* 备注下：
* 可能存在异常情况：
* 
* 如果，当前企业设置，强制绑定保险，不可取消； 员工a 设置不可购买保险； 此时出现死循环，该员工提交不了订单！
* 
* 解决方案：修改企业设置 或者 修改员工a可预订保险权限
* 
* 
* **/ 
bx.cxrListIsCanBookBx=(cxrList)=>{
	// canBookType  1 可以预订  2 部分预订  3 不可预订
	let canBookType = 2;
	cxrList = cxrList || [];
	// 可以预订保险人员
	let filterCxrList = cxrList.filter(item=>{
		return item.bxBook == 1
	})
	// 不可预订保险人员
	let filterNoCxrList = cxrList.filter(item=>{
		return item.bxBook != 1
	})
	// 全部可以预订
	if(filterCxrList.length == cxrList.length) {
		canBookType = 1
	};
	// 全部可不预订
	if(filterNoCxrList.length == cxrList.length){
		canBookType = 3
	}
	return {
		canBookType:canBookType,
		cxrList:cxrList,
		canCxrList:filterCxrList,
		noCanCxrList:filterNoCxrList,
		noCanNameStr:filterNoCxrList.map(item=>{
			return item.empName || item.chName || item.cxrName || item.passengerName || ''
		}).join('、'),
	} 
}

export default bx